module.exports = __webpack_public_path__ + "img/iripple-logo-original-primary.f28e6aec.png";